import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {CaseEntitiesActions, DashboardActions} from "../actions";
import {catchError, map, mergeMap} from "rxjs";
import {ToastrService} from "ngx-toastr";
import {ApiError, CaseEntitiesService} from "@esa/api";
import {Router} from "@angular/router";
import {Store} from "@ngrx/store";
import {ApiErrorHandlerService} from "../../services";

@Injectable()
export class CaseEntitiesEffects {

  getCaseEntityById$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CaseEntitiesActions.getCaseEntityById),
      mergeMap(({ id }) => this._caseEntitiesService.getApiCaseEntity1(id).pipe(
        map(selectedCaseEntity => CaseEntitiesActions.getCaseEntityByIdSuccess({ selectedCaseEntity })),
        catchError((error: ApiError) => {
          return this.apiErrorHandlerService.handleError(error, CaseEntitiesActions.getCaseEntityByIdError());
        })
      ))
    );
  });

  createCaseEntity$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CaseEntitiesActions.createCaseEntity),
      mergeMap(({ caseEntity }) => this._caseEntitiesService.postApiCaseEntity(caseEntity).pipe(
        map(response => {
          this.toastrService.success('Case created successfully');
          this._store.dispatch((CaseEntitiesActions.setSelectedCaseEntityId({ selectedCaseEntityId: response.value })));
          this.router.navigateByUrl('/case-management/case-details');
          return CaseEntitiesActions.createCaseEntitySuccess({ showEditForm: true });
        }),
        catchError((error: ApiError) => {
          return this.apiErrorHandlerService.handleError(error, CaseEntitiesActions.createCaseEntityError());
        })
      ))
    );
  });

  updateCaseEntity$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CaseEntitiesActions.updateCaseEntity),
      mergeMap(({ caseEntity }) => this._caseEntitiesService.putApiCaseEntity(caseEntity.id, caseEntity).pipe(
        map(response => {
          this.toastrService.success('Case updated successfully.');
          this.router.navigateByUrl('case-management');
          this._store.dispatch(DashboardActions.getIncomingDashCaseFiles( { searchTerm: '', pageNumber: 1, pageSize: 10 }));
          this._store.dispatch(DashboardActions.getOutgoingDashCaseFiles( { searchTerm: '', pageNumber: 1, pageSize: 10 }));
          this._store.dispatch(DashboardActions.getArchivedDashCaseFiles( { searchTerm: '', pageNumber: 1, pageSize: 10 }));
          this._store.dispatch(DashboardActions.getActiveDashCaseFiles( { searchTerm: '', pageNumber: 1, pageSize: 10 }));
          return CaseEntitiesActions.updateCaseEntitySuccess();
        }),
        catchError((error: ApiError) => {
          return this.apiErrorHandlerService.handleError(error, CaseEntitiesActions.createCaseEntityError());
        })
      ))
    );
  });

  constructor(
    private actions$: Actions,
    private _caseEntitiesService: CaseEntitiesService,
    private toastrService: ToastrService,
    private router: Router,
    private _store: Store,
    private apiErrorHandlerService: ApiErrorHandlerService
  ) {}
}
